// Custom field related constants
export const TABLE_FORMAT_REGEX =
  /^(?:"(?:[^"]|"")*"|[^";,{}]+)(?:\s*,\s*(?:"(?:[^"]|"")*"|[^";,{}]+))*(?:\s*;\s*(?:"(?:[^"]|"")*"|[^";,{}]+)(?:\s*,\s*(?:"(?:[^"]|"")*"|[^";,{}]+))*)*(?:\s*;\s*)?$/;

export const CUSTOM_FIELD_TYPES = {
  TEXT: "text",
  NUMERIC: "numeric",
  BOOLEAN: "boolean",
  SELECT: "select",
  DATE: "date",
  LIST: "list",
  TABLE: "table",
};

export const CUSTOM_FIELD_ERROR_MESSAGES = {
  TABLE:
    'Invalid table format. Use semicolons to separate rows: Column1, Column2; Row1Val1, Row1Val2. For values with commas, use quotes: "Value with, comma"',
};
